<template>
    <v-menu
      ref="datetimeDialog"
      v-model="datetimeDialog"
      :close-on-content-click="false"
      transition="scale-transition"
      max-width="290px"
      offset-y
    >
      <!-- :close-on-click="false" -->
      <!-- max-width="290px"
          :label="label" -->
      <template v-slot:activator="{ on: activatorOn }">
        <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
        <v-text-field
          v-model="innerValue"
          :append-icon="prependIcon"
          v-on="{ ...$listeners, ...activatorOn }"
          v-bind="$attrs"
          :label="label"
          :readonly="$attrs.readonly"
          :error-messages="errors"
          autocomplete="off"
          @blur="formatDate"
        ></v-text-field>
        </ValidationProvider>
      </template>
      <v-card>
        <v-row dense>
          <v-col>
            <v-date-picker
              v-model="pickerDate"
              no-title
              v-bind="$attrs"
              :locale="$i18n.locale"
            ></v-date-picker>
          </v-col>
        </v-row>
        <v-row  dense>
          <v-col class="mx-4">
            <rx-time
              v-model="pickerTime"
              v-bind="$attrs"
              :label="$t('common.lbl.set_times')"
              format="ampm"
              filled
              dense
            ></rx-time>
          </v-col>  
        </v-row>
        <v-card-actions>
          <v-spacer></v-spacer>
          <rx-btn text @click="cancel">
            {{$t("common.btn.cancel")}}
          </rx-btn>
          <rx-btn text color="primary" @click="confirm">
             {{$t("common.btn.confirm")}}
          </rx-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  components: {
    ValidationProvider,
  },
  props: {
    prependIcon: {
      type: String,
      default: "mdi-calendar",
    },
     label: {
      type: String,
    }, 
    rules: {
      type: [Object, String],
      default: "",
    }, 
    value: {
      type: [String, Date]
    },
  },
  computed: {
    pickerDatetime() {
      return `${this.pickerDate} ${this.pickerTime}`;
    }
  },
  data() {
    return {
      datetimeDialog: false,
      pickerDate: this.$moment(new Date(this.value)).format("YYYY-MM-DD"),
      pickerTime: this.$moment(new Date(this.value)).format("HH:mm"),
      innerValue: this.value,
    };
  },
  methods: {
    formatDate () {
      if(!this.innerValue){
        this.innerValue = null;
        this.pickerDate = null;
        this.pickerTime = null;
      } else {
        let dt = this.innerValue.replace(/-/g,"").replace(/:/g,"").replace(/ /g,"");
        const year = dt.substring(0,4);
        const month = dt.substring(4,6);
        const day = dt.substring(6,8);
        const hour = dt.substring(8,10);
        const minute = dt.substring(10,12);
        

        dt = `${year}-${month}-${day} ${hour}:${minute}`;
          try {
            this.innerValue = this.$moment(new Date(dt)).format("YYYY-MM-DD HH:mm");
          } catch(e) {
            this.innerValue = null;
          }
        this.$emit("blur", this.innerValue);
      }
    },
    confirm() {
      this.innerValue  = this.pickerDatetime;
      // this.$emit("input", this.pickerDatetime);
      this.datetimeDialog=false;
    },
    cancel() {
      this.pickerDate = this.$moment(new Date(this.innerValue)).format("YYYY-MM-DD");
      this.pickerTime = this.$moment(new Date(this.innerValue)).format("HH:mm");
      this.datetimeDialog=false;
    }
  },
  watch: {
    // Handles internal model changes.
    innerValue(newVal) {
      // this.dateFormatted = this.formatDate(this.innerValue);
      if(newVal) {
        this.pickerDate = this.$moment(new Date(newVal)).format("YYYY-MM-DD");
        this.pickerTime = this.$moment(new Date(newVal)).format("HH:mm");
      } else {
        this.pickerDate = null;
        this.pickerTime = null;
      }
      this.$emit("input", newVal);
    },
    // Handles external model changes.
    value(newVal) {
      this.innerValue = newVal;
      if(newVal) {
        this.innerValue = newVal;
        this.pickerDate = this.$moment(new Date(newVal)).format("YYYY-MM-DD");
        this.pickerTime = this.$moment(new Date(newVal)).format("HH:mm");
      } else {
        this.innerValue = null;
        this.pickerDate = null;
        this.pickerTime = null;
      }
    },
  },
  created() {
  },
};
</script>

<style>
</style>